export default __webpack_public_path__ + "static/media/warbishop_black.84a414c3.svg";